const handleSavableSubmission = ev => {
  if (document.activeElement.getAttribute("name") === "action_doComplete") {
    setTimeout(() => {
      const errors = ev.target.querySelectorAll("span.error")

      if (!errors.length) {
        window.dataLayer.push({
          event: "savable_form_submission",
          form_action: "submitted",
          form: ev.target.dataset.gaFormName,
        })
      }
    }, 300)
  } else {
    window.dataLayer.push({
      event: "savable_form_submission",
      form_action: "saved",
      form: ev.target.dataset.gaFormName,
    })
  }
}

const handleUserFormSubmission = ev => {
  setTimeout(() => {
    const errors = ev.target.querySelectorAll("span.error")

    if (!errors.length) {
      window.dataLayer.push({
        event: "userform_submisison",
        form: ev.target.dataset.gaFormName,
      })
    }
  }, 300)
}

export default function() {
  const savableForms = document.querySelectorAll("form.userform.savable-form")
  const userForms = document.querySelectorAll("form.userform:not(.savable-form)")

  for (let sf = 0; sf < savableForms.length; sf++) {
    savableForms[sf].addEventListener("submit", handleSavableSubmission)
  }

  for (let uf = 0; uf < userForms.length; uf++) {
    userForms[uf].addEventListener("submit", handleUserFormSubmission)
  }
}
